<!-- eslint-disable vue/no-v-html -->
<script lang="ts">
import { defineComponent, toRefs } from 'vue';
import type { HekateDisplayField } from '@onshape/www-inertia';
import { Trans } from '@onshape/www-inertia';

export default defineComponent({
  props: {
    field: {
      required: true,
      type: Object as unknown as () => HekateDisplayField,
    },
  },
  setup(props: { field: HekateDisplayField }) {
    const { field } = toRefs(props);

    const parsedValue = Trans.markdown(field.value.name);

    return {
      parsedValue,
    };
  },
});
</script>
<template>
  <div
    :class="['readonly-description-field', field.displayVariantType]"
    :html-name="field.htmlName"
  >
    <p v-html="parsedValue" />
  </div>
</template>

<style lang="scss" scoped>
@use '../../../style/vars.scss' as vars;

.readonly-description-field {
  border: 8px color #eee;

  // Large header on top of a group, the other option is `.field-group-body`
  &.field-group-header {
    p {
      border: none;
      font-size: 1.2em;
      font-weight: 500;
      margin-top: 2px;
      margin-bottom: 0px;
      padding-left: 0px;
    }
  }

  p {
    margin-top: 0px;
    -webkit-font-smoothing: antialiased;
    -webkit-box-direction: normal;
    box-sizing: border-box;
    font-size: 14px;
    padding: 4px;
    border-bottom: 1px solid vars.$color-input-border;
    border-right: 1px solid vars.$color-input-border;
    border-left: 1px solid vars.$color-input-border;
    margin-bottom: 18px;
    margin-top: -8px;
    width: 100%;

    font-family: 'Raleway', 'Arial', sans-serif;
    font-weight: 400;
    line-height: 1.2;
    text-rendering: optimizeLegibility;
    color: #2f4265;
  }
}

[field-name='hint'] {
  max-width: 430px;
  margin: auto;
  padding-top: 4px;
}
</style>
